import React from "react";
import "./Management.css";
import { getStoredData } from "../../api/fetchData.jsx";
import AdminMenu from "../../components/AdminMenu/AdminMenu";

const Management = () => {
  const menuItems = getStoredData()?.[0].Dashboard;

  return (
    <div className="admin-dashboard">

      {/* EXISTING LAYOUT (menu + functions) */}
      <div className="home-content-container">
        <AdminMenu menuItems={menuItems} />
      </div>
    </div>
  );
};

export default Management;
